import { createApp } from 'vue'
import App from './App.vue'

createApp(App, (window as any).couponProps ).mount('#app')
